import Vue from 'vue'
import App from './App.vue'
import '../registerServiceWorker'
import router from './router'
import store from '../store'
// 项目启动时需要处理的东西
import Start from '../start'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Start.run({ store })
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
